import React from 'react'
import SaveDocument from '../containers/SaveDocument'
import NewDocument from '../containers/NewDocument'
import OpenDocument from '../containers/OpenDocument'
import DocumentTitle from "../containers/DocumentTitle"
import CopyPreset from "../containers/CopyPreset"
import Panic from "../containers/Panic"
import Settings from "../containers/Settings"
import Connect from "../containers/Connect"
import UndoRedo from "../containers/UndoRedo"
import styled from "styled-components"
import {ReactComponent as Logo} from "../images/logo.svg"
import {connect} from 'react-redux'
import {switchScreen} from '../actions'
import Download from "../containers/Download"
import PresetSelector from "../containers/PresetSelector"
import ColorSelector from "../containers/ColorSelector"
import Upload from '../containers/Upload'
const StyledNavBar = styled.div`
    background:#222222;
    border-bottom:1px solid black;
    height:55px;
    width:100%;
`
const LogoTitle = styled.h1`
    text-transform:uppercase;
    font-family:'Roboto Condensed';
    font-size:24px;
    margin:0;
    padding:0;
    top:3px;
    position:relative;
    line-height:55px;
    display:block;
    float:left;
    margin-right:calc(10px + 5%);
    font-weight:300;
`
const StyledUL = styled.ul`
    list-style-type:none;
    display:block;
    float:left;
    margin-right:40px;
`
const StyledLogo = styled(Logo)`
   float:left;
   margin:5px 10px;
   cursor:pointer;
`


const NavBar = ({dispatch}) => (
    <StyledNavBar>
        <StyledLogo onClick= {() => dispatch(switchScreen({screen:"about"}))}/>
        <LogoTitle>DataLooper Config</LogoTitle>
        <StyledUL>
            <DocumentTitle />
            <NewDocument name="New Document" icon="NewDocument" />
            <OpenDocument name="Open Document" icon="Open" />
            <SaveDocument name="Save Document" icon="Save" />
        </StyledUL>
        <StyledUL>
            <Connect name="Connect" icon="Connection" />
            <Upload name="Upload" icon="Upload" />
            <Download name="Download" icon="Download" />
        </StyledUL>
        <StyledUL>
            <UndoRedo/>
        </StyledUL>
        <StyledUL>
            <Settings name="Settings" icon="Settings" />
            <Panic name="Panic" icon="Panic" />
        </StyledUL>
        <StyledUL>
            <PresetSelector name="Preset" />
            <CopyPreset name="Copy Preset" icon="Copy" />
            <ColorSelector />
        </StyledUL>
        </StyledNavBar>
)
export default connect()(NavBar)